// use crypto-browserify@1.0.9 to minify dist size
module.exports = require('crypto-browserify');



//////////////////
// WEBPACK FOOTER
// ./~/ali-oss/shims/crypto.js
// module id = 383
// module chunks = 0 1